var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceSectionPopupEventMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_394_454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4167 13.8521C16.2353 13.8521 12.8333 17.2541 12.8333 21.4354C12.8333 25.5923 16.2353 28.9733 20.4167 28.9733C24.598 28.9733 28 25.5713 28 21.3899C28 17.2331 24.598 13.8521 20.4167 13.8521ZM20.4167 27.8066C16.8793 27.8066 14 24.9483 14 21.4354C14 17.8969 16.8793 15.0188 20.4167 15.0188C23.954 15.0188 26.8333 17.8771 26.8333 21.3899C26.8333 24.9284 23.954 27.8066 20.4167 27.8066ZM21.9963 22.1436C22.2238 22.3711 22.2238 22.7409 21.9963 22.9684C21.882 23.0828 21.7327 23.1388 21.5833 23.1388C21.434 23.1388 21.2847 23.0816 21.1703 22.9684L20.0037 21.8018C19.894 21.6921 19.8333 21.5439 19.8333 21.3888V19.0554C19.8333 18.7334 20.0947 18.4721 20.4167 18.4721C20.7387 18.4721 21 18.7334 21 19.0554V21.1473L21.9963 22.1436ZM22.75 3.3066H21V1.5566C21 1.2346 20.7387 0.973267 20.4167 0.973267C20.0947 0.973267 19.8333 1.2346 19.8333 1.5566V3.3066H8.16667V1.5566C8.16667 1.2346 7.90533 0.973267 7.58333 0.973267C7.26133 0.973267 7 1.2346 7 1.5566V3.3066H5.25C2.3555 3.3066 0 5.6621 0 8.5566V23.7233C0 26.6178 2.3555 28.9733 5.25 28.9733H12.25C12.572 28.9733 12.8333 28.7119 12.8333 28.3899C12.8333 28.0679 12.572 27.8066 12.25 27.8066H5.25C2.99833 27.8066 1.16667 25.9749 1.16667 23.7233V11.4733H26.8333V13.2233C26.8333 13.5453 27.0947 13.8066 27.4167 13.8066C27.7387 13.8066 28 13.5453 28 13.2233V8.5566C28 5.6621 25.6445 3.3066 22.75 3.3066ZM1.16667 10.3066V8.5566C1.16667 6.30493 2.99833 4.47327 5.25 4.47327H22.75C25.0017 4.47327 26.8333 6.30493 26.8333 8.5566V10.3066H1.16667Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.3001,
    cy: 21.2732,
    r: 7.7,
    fill: "#72B01D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3001 19.1732L19.7202 21.4927C19.6445 21.7955 19.7145 22.1163 19.9095 22.36L21.0001 23.7232",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_394_454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.973267)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceSectionPopupEventMan);
export default __webpack_public_path__ + "static/media/service_section_popup_event_man.6889bd1560737de5110bbca3fd080dd9.svg";
export { ForwardRef as ReactComponent };